export default function toCamelCase(text: string): string {
  if (!text) return '';

  return text
    .replace(/[-_]+([a-zA-Z0-9])/g, (_, match) => match.toUpperCase())
    .replace(/^[A-Z]/, (match) => match.toLowerCase());
}
